export const cpdsMediaQueryVals = {
  cpds_small_lower_limit: '320px',
  cpds_small_upper_limit: '767px',
  cpds_medium_lower_limit: '768px',
  cpds_medium_upper_limit: '1279px',
  cpds_large_lower_limit: '1280px',
  cpds_large_upper_limit: '1679px',
  cpds_large_extended_lower_limit: '1680px',
  cpds_hero_small_lower_limit: '320px',
  cpds_hero_small_upper_limit: '1023px',
  cpds_hero_large_lower_limit: '1024px',
} as const;

export const mediaQueries = {
  desktop: `(max-width: ${cpdsMediaQueryVals.cpds_large_upper_limit})`,
  tablet: `(max-width: ${cpdsMediaQueryVals.cpds_medium_upper_limit})`,
  mobile: `(max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit})`,
};

export type MediaQueryValues = (typeof cpdsMediaQueryVals)[keyof typeof cpdsMediaQueryVals];
